import { render, staticRenderFns } from "./orgBgmRelationQuery.vue?vue&type=template&id=40343124&scoped=true"
import script from "./orgBgmRelationQuery.vue?vue&type=script&lang=js"
export * from "./orgBgmRelationQuery.vue?vue&type=script&lang=js"
import style0 from "./orgBgmRelationQuery.vue?vue&type=style&index=0&id=40343124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40343124",
  null
  
)

export default component.exports